import { render, staticRenderFns } from "./toggle-btn.vue?vue&type=template&id=dce76e1a"
import script from "./toggle-btn.vue?vue&type=script&lang=js"
export * from "./toggle-btn.vue?vue&type=script&lang=js"
import style0 from "./toggle-btn.vue?vue&type=style&index=0&id=dce76e1a&lang=scss&scopted=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce76e1a')) {
      api.createRecord('dce76e1a', component.options)
    } else {
      api.reload('dce76e1a', component.options)
    }
    module.hot.accept("./toggle-btn.vue?vue&type=template&id=dce76e1a", function () {
      api.rerender('dce76e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toggle-btn.vue"
export default component.exports